module.exports = __webpack_public_path__ + "img/237.compressor.ee9b159e.svg";